/**
 * Content entry point. Only pt-BR exists today; adding a locale means adding
 * its modules here (the types make missing strings a compile error).
 */

import type { RouteId } from "../site/routes";
import { APPS_PT_BR } from "./apps/pt-BR";
import { BUSINESS_PT_BR } from "./business/pt-BR";
import { DEVELOPERS_PT_BR } from "./developers/pt-BR";
import { HUB_PT_BR } from "./hub/pt-BR";
import { COMMON_PT_BR } from "./common/pt-BR";
import { ROUTE_COPY_PT_BR } from "./routes/pt-BR";
import type {
  AppsCopy,
  BusinessCopy,
  CommonCopy,
  DevelopersCopy,
  HubCopy,
  Locale,
  RouteCopy,
} from "./types";

export type {
  AppId,
  AppsCopy,
  BusinessCopy,
  CommonCopy,
  ComingSoonAppId,
  DevelopersCopy,
  HubCopy,
  Locale,
  RouteCopy,
} from "./types";

export const DEFAULT_LOCALE: Locale = "pt-BR";

const ROUTE_COPY: Record<Locale, Record<RouteId, RouteCopy>> = {
  "pt-BR": ROUTE_COPY_PT_BR,
};

const COMMON: Record<Locale, CommonCopy> = {
  "pt-BR": COMMON_PT_BR,
};

export function getRouteCopy(
  id: RouteId,
  locale: Locale = DEFAULT_LOCALE
): RouteCopy {
  return ROUTE_COPY[locale][id];
}

export function getCommonCopy(locale: Locale = DEFAULT_LOCALE): CommonCopy {
  return COMMON[locale];
}

const APPS: Record<Locale, AppsCopy> = {
  "pt-BR": APPS_PT_BR,
};

export function getAppsCopy(locale: Locale = DEFAULT_LOCALE): AppsCopy {
  return APPS[locale];
}

const BUSINESS: Record<Locale, BusinessCopy> = {
  "pt-BR": BUSINESS_PT_BR,
};

export function getBusinessCopy(locale: Locale = DEFAULT_LOCALE): BusinessCopy {
  return BUSINESS[locale];
}

const DEVELOPERS: Record<Locale, DevelopersCopy> = {
  "pt-BR": DEVELOPERS_PT_BR,
};

export function getDevelopersCopy(
  locale: Locale = DEFAULT_LOCALE
): DevelopersCopy {
  return DEVELOPERS[locale];
}

const HUB: Record<Locale, HubCopy> = {
  "pt-BR": HUB_PT_BR,
};

export function getHubCopy(locale: Locale = DEFAULT_LOCALE): HubCopy {
  return HUB[locale];
}
